function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m11.929 18.136c1.619 0 2.932 1.313 2.932 2.932s-1.312 2.932-2.932 2.932-2.932-1.313-2.932-2.932 1.313-2.932 2.932-2.932zm11.19-8.258-9-9c-1.171-1.171-3.071-1.171-4.242 0s-1.171 3.071 0 4.242l6.866 6.866-4.493 4.588 2.119 2.211c.581.621.901 1.432.901 2.282 0 .313-.044.615-.125.903l7.974-7.851c1.172-1.17 1.172-3.069 0-4.241zm-11.45-2.387-2.081-2.081c-.644-.644-.999-1.5-.999-2.41 0-.333.048-.659.14-.97l-7.853 7.779c-1.17 1.17-1.17 3.067 0 4.238l7.824 7.875c-.072-.273-.111-.559-.111-.854 0-1.842 1.499-3.341 3.341-3.341.351 0 .69.055 1.008.156l-5.706-5.955z"
});

var SvgGoogletagmanager = function SvgGoogletagmanager(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGoogletagmanager, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "googletagmanager.svg";
export { ForwardRef as ReactComponent };